
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import utils from '@/utils/utils';

export default {
name: 'expense-detail',
components: {
Popup,
Flexbox,
FlexboxItem,
},
props: {
value: {
type: Boolean,
default: false
},
startDate: Date,
endDate: Date,
total: {
type: Number | String,
default: 0,
},
onlinePay: String,    // 在线支付金额
bccDiscount: {    // BCC优惠金额
type: Number | String,
default: 0,
},
couponDiscount: { // 优惠券优惠金额
type: Number | String,
default: 0,
},
roomCount: {
type: Number | String,
default: 0,
},
currencyCode: {
type: String,
default: 'CNY',
},




priceList: {
type: Array,
default(){
return [];
},
},
},
data(){
return {
dateArr: [],
};
},
computed: {
show: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
}
},
lanType(){
return +window.localStorage.getItem('lan_type');
},
},
methods: {
onHideDetail(){
this.$emit('input', false);
},
},
}



// WEBPACK FOOTER //
// ./src/views/order/components/ExpenseDetail.vue